import { useGlobalState } from '../../contexts/GlobalContext';
import { ParamsGetOrders, ResponseGetOrders } from '@vindr/services/apis/order.api';
import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
import CreateOrderModal from '../Order/CreateOrder/CreateOrderModal';
import { Button } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Updater } from 'use-immer';
import CreateReception from './CreateReception';

const CreateOrder = ({
  selectedRowKeys,
  setSelectedRowKeys,
  openChangeStatusModal,
  popupAddReception,
  setPopupAddReception,
  setPopupAddReceptionQms,
  params,
}: {
  selectedRowKeys: ResponseGetOrders['data'];
  setSelectedRowKeys: Updater<ResponseGetOrders['data']>;
  openChangeStatusModal: () => void;
  params: ParamsGetOrders;
  popupAddReception: { open: boolean; action: string };
  setPopupAddReception: (value: { open: boolean; action: string }) => void;
  setPopupAddReceptionQms: (value: { open: boolean }) => void;
}) => {
  const { t } = useTranslation('Vindoc');
  const { message, keycloak } = useGlobalState();
  const [popupAddOrder, setPopupAddOrder] = useState(false);
  // const [popupAddReception, setPopupAddReception] = useState({ open: false, action: null });
  return (
    <div className="flex items-end space-x-2 overflow-auto pt-3 pb-6">
      {keycloak.hasOneOfPerm([PERMISSIONS.order.create]) && (
        <Button
          className={`batch-button flex items-center
          justify-center text-base`}
          size="small"
          onClick={() => setPopupAddOrder(true)}
          style={{ width: 90 }}
        >
          {t('Add Order')}
        </Button>
      )}
      {keycloak.hasOneOfPerm([PERMISSIONS.order.receive]) && ( //? Hide when no have Order Create Permission
        <Button
          className={`batch-button flex items-center
        justify-center text-base`}
          size="small"
          onClick={() => setPopupAddReception({ open: true, action: 'receive' })}
          style={{ width: 90 }}
          disabled={
            !selectedRowKeys.length || //? Disabled when no have selected row
            selectedRowKeys.some(
              //? Disabled when have selected row with status is not NEW or CANCEL
              (item) =>
                ![ORDER_STATUS.NEW, ORDER_STATUS.CANCEL, ORDER_STATUS.SCHEDULED].includes(
                  item.status
                )
            )
          }
        >
          {t('Receive')}
        </Button>
      )}
      {keycloak.hasOneOfPerm([PERMISSIONS.order.receiveqms]) && ( //? Hide when no have Order Create Permission
        <Button
          className={`batch-button flex items-center
        justify-center text-base`}
          size="small"
          onClick={() => setPopupAddReceptionQms({ open: true })}
          disabled={
            !selectedRowKeys.length || //? Disabled when no have selected row
            selectedRowKeys.some(
              //? Disabled when have selected row with status is not NEW or CANCEL
              (item) =>
                ![ORDER_STATUS.NEW, ORDER_STATUS.CANCEL, ORDER_STATUS.SCHEDULED].includes(
                  item.status
                )
            )
          }
        >
          {t('Receive QMS')}
        </Button>
      )}
      {keycloak.hasOneOfPerm([PERMISSIONS.order.update]) && ( //? Hide when no have Order Create Permission
        <Button
          className={`batch-button flex items-center
        justify-center text-base`}
          size="small"
          onClick={() => setPopupAddReception({ open: true, action: 'changeDevice' })}
          style={{ width: 110 }}
          disabled={
            !selectedRowKeys.length //? Disabled when no have selected row
          }
        >
          {t('Change Device')}
        </Button>
      )}
      {keycloak.hasOneOfPerm([PERMISSIONS.order.changestatus]) && (
        <Button
          className={`batch-button flex items-center
        justify-center text-base`}
          size="small"
          onClick={() => openChangeStatusModal()}
          style={{ width: 110 }}
          disabled={
            !selectedRowKeys?.length || //? Disabled when no have selected row
            !selectedRowKeys?.every((item) => item.status === selectedRowKeys[0].status) ||
            selectedRowKeys.some(
              //? Disabled when have selected row with status is READING, SUBMITTED, APPROVED, COMPLETED
              (item) =>
                [
                  ORDER_STATUS.READING,
                  ORDER_STATUS.SUBMITTED,
                  ORDER_STATUS.APPROVED,
                  ORDER_STATUS.COMPLETED,
                ].includes(item.status)
            )
          }
        >
          {t('Change Status')}
        </Button>
      )}
      {popupAddOrder ? (
        <CreateOrderModal
          visible={popupAddOrder}
          onCancel={() => setPopupAddOrder(false)}
          onFinish={() => setPopupAddOrder(false)}
          message={message}
          defaultInstitutionId={keycloak.userInfo?.default_institution_id}
        />
      ) : null}
      {popupAddReception?.open ? (
        <CreateReception
          action={popupAddReception.action}
          open={popupAddReception.open}
          onCancel={() => setPopupAddReception({ open: false, action: null })}
          {...{ selectedRowKeys, setSelectedRowKeys, params }}
        />
      ) : null}
    </div>
  );
};

export default CreateOrder;
